import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  ComponentResourcePicker,
  ComponentResourcePickerSchema,
} from './ComponentResourcePicker';
import {
  GroupResourcePicker,
  GroupResourcePickerSchema,
} from './GroupResourcePicker';

export const ComponentResourcePickerExtension = FormFieldBlueprint.make({
  name: 'ComponentResourcePicker',
  params: {
    field: async () =>
      createFormField({
        name: 'ComponentResourcePicker',
        component: ComponentResourcePicker,
        schema: ComponentResourcePickerSchema,
      }),
  },
});

export const GroupResourcePickerExtension = FormFieldBlueprint.make({
  name: 'GroupResourcePicker',
  params: {
    field: async () =>
      createFormField({
        name: 'GroupResourcePicker',
        component: GroupResourcePicker,
        schema: GroupResourcePickerSchema,
      }),
  },
});
